<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="step2">
    <a-spin :spinning="spinning">
      
      <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 8 }">
        <PlateTitle title="项目资料" />
        <div class="Tips">
          <i class="el-icon-warning"></i>
          上传文件需加盖公章，单页资料只需要盖封面章，两页以上资料需盖封面章和骑缝章
        </div>
        <a-form-item label="中标通知书" has-feedback prop="zbtzs">
          <a-upload
            :max-count="1"
            :action="uploadAction"
            :beforeUpload="beforeUploadMore"
            list-type="picture"
            @change="handleChange($event,'1')"
          >
            <a-button> <a-icon type="upload" /> 上传文件 </a-button>
          </a-upload>
          <p class="p-tip">请上传高清电子扫描件或图片，大小不超过10M</p>
        </a-form-item>
        
        <a-form-item label="招标文件" has-feedback prop="abwj">
          <a-upload
            :max-count="1"
            :action="uploadAction"
            :beforeUpload="beforeUploadMore"
            list-type="picture"
            @change="handleChange($event,'2')"
          >
            <a-button> <a-icon type="upload" /> 上传文件 </a-button>
          </a-upload>
          <p class="p-tip">请上传高清电子扫描件或图片，大小不超过10M</p>

        </a-form-item>
        <a-form-item label="施工合同" has-feedback prop="sght">
          <a-upload
            :max-count="1"
            :action="uploadAction"
            :beforeUpload="beforeUploadMore"
            list-type="picture"
            @change="handleChange($event,'3')"
          >
            <a-button> <a-icon type="upload" /> 上传文件 </a-button>
          </a-upload>
          <p class="p-tip">请上传高清电子扫描件或图片，大小不超过10M</p>

        </a-form-item>
        <PlateTitle title="保函格式选择" />
        <div class="Tips">
          <i class="el-icon-warning"></i>
          <span> 1、保函格式请提前同受益人沟通，默认格式无需机构风控审核可直接使用可缩短开函时间；自定义格式需机构风控审核后才使用，开函时 间可能延长。
          </span>
          <p>2、自定义格式需上传Word文件，大小不超过10M。
          </p>
        </div>
        <a-form-item label="" prop="unitAptitude" 
        class="radioGroup"
        >
          <a-radio-group 
          v-model="form2.backletterFormat"
          style="width: 350px;"
          @change="backletterFormatSelect"
          >
            <a-radio v-for="item in backletterFormatList" :key="item.formatPath" :value="item.value">
              <span>{{ item.label }}</span> 
              <a v-if="item.formatPath" href="#" @click="yulang(item.formatPath)">预览保函模板</a>
            </a-radio>
          </a-radio-group>
          
        </a-form-item>
        <a-form-item label="自定义格式" prop="unitAptitude" class="" v-if="form2.backletterFormat == '99'">
          <a-upload
            :accept="accept"
            :max-count="1"
            :action="uploadAction"
            :beforeUpload="beforeUpload"
            @change="handleChange($event,'99')"
          >
            <a-button> <a-icon type="upload" /> 上传文件 </a-button>
          </a-upload>
        </a-form-item>

        
      </a-form>
    </a-spin>

  </div>
</template>
<script>
import PlateTitle from "@/components/PlateTitle";
import UloadBtn from "@/components/UploadBtn/uloadBtn.vue";

import {
  getbackletterFormat,
} from "@/api/nonBidInsure.js";
export default {
  components: {},
  components: {
    PlateTitle,
    UloadBtn
  },
  props: {
    needData: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      spinning:false,
      backletterFormatList:[],
      form: this.$form.createForm(this, { name: "Step2Form" }),
      uploadAction: process.env.VUE_APP_FIRST_URL + '/api/contract/upload',
      uloadList_zdy:[],
      
      accept: ".doc,.docx",
      form2:{
        fileList:[],
        backletterFormat:'',
        formatPath:'',
        uloadList_zbtzs:[],
        uloadList_zbwj:[],
        uloadList_sght:[],
        }
    };
  },
  watch: {
    form2:{
      handler: function (newVal, oldVal) {
        if (newVal) {
          
          this.$emit('StepData2', newVal);
        }
      },
      deep: true,
    },
  },
  mounted() {
    // setTimeout(() => {
      this.getbackletterFormatA()
      // }, 100);
  },
  methods: {
    backletterFormatSelect(e){
      let val = e.target.value;
      
      this.backletterFormatList.map(item=>{
        if(val == item.value){
          
          this.form2.formatPath = item.formatPath
          this.form2.backletterFormat = val
        }
      })
    },
    yulang(url){
      window.open('/api/contract/fileView?source='+url)
    },
    getbackletterFormatA(){
      if(this.needData.institutionId){
        getbackletterFormat({ institutionId: this.needData.institutionId }).then(res => {
          if (res.status == 200) {
            this.backletterFormatList = res.data
            this.form2.backletterFormat = this.backletterFormatList[0].value
            this.form2.formatPath = this.backletterFormatList[0].formatPath
          }
        })
      }
    },
    beforeUpload(file,fileList) {
      if (this.uloadList_zdy.length >= 1) {
        this.$message.error("仅允许上传一个文件！");
        return Upload.LIST_IGNORE
      }
      // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      // if (!isJpgOrPng) {
      //   this.$message.error('只能上传 JPG/PNG 格式的文件!');
      // }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('文件大小不能超过 10MB!');
      }
      return  isLt2M;
    },
    handleUpload(info){

    },
    beforeUploadMore(file,fileList) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('文件大小不能超过 10MB!');
      }
      return  isLt2M;
    },
    handleChange(info,action) {
      if (info.file.status !== 'uploading') {}
      if (info.file.status === 'done') {
        if(info.file.response.code == '0000'){
          this.$message.success(`文件上传成功`);
        }else{
          this.$message.error(info.file.response.msg);
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`文件上传失败`);
      }
      console.log(info, 999)
      
      if(info.file.response&&info.file.response.code =='0000'){
        let Arrays = []
        info.fileList.map(item=>{
          Arrays.push({
              category:action,
              originName:item.name,
              fileName:item.name,
              filePath:item.response.data.url,
            })
          })
        if(action =='1'){
          this.form2.uloadList_zbtzs = Arrays
        }else if(action =='2'){
          this.form2.uloadList_zbwj = Arrays
        }else if(action =='3'){
          this.form2.uloadList_sght = Arrays
        }else if(action =='99'){
          this.uloadList_zdy = info.fileList
          this.form2.formatPath = info.file.response.data.url
        }
      }
    },
  },
};
</script>

<style lang='less' scoped>
::v-deep .ant-form-item-control {
  margin-left: 0px;
  width: 400px;
  word-wrap: break-word;
}
.step2 .ant-row {
  display: inline-block;
}
.p-tip{
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: rgba(0,0,0,0.4);
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.Tips{
  margin: 24px auto;
  width: 930px;
  line-height: 22px;
  background: #EFF2FF;
  border-radius: 6px 6px 6px 6px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #125AFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  padding: 16px 24px;
}
.Tips i{
  color: #125AFF;
}
::v-deep .ant-radio-wrapper{
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0,0,0,0.9);
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.radioGroup{
  margin-left: 126px;
  display: block!important;
}
.radioGroup span{
  min-width: 260px;
  display: inline-block;
}
.radioGroup a{
  margin-left: 10px;
}
.none ::v-deep .ant-upload{
  position: absolute;
  top: 100px;
  left: 0;
}
</style>
